// Mock data for BrandingFrame website

export const portfolioItems = [
  {
    id: 1,
    title: "Brand Story",
    thumbnail: "https://customer-assets.emergentagent.com/job_brand-frame/artifacts/dy4o90ih_AEP.png",
    videoUrl: "https://vimeo.com/showcase/12164306/embed",
    description: "Helping brands articulate who they are and why they matter."
  },
  {
    id: 2,
    title: "Product Story",
    thumbnail: "https://customer-assets.emergentagent.com/job_brand-frame/artifacts/v48axwq6_KJ.png",
    videoUrl: "https://vimeo.com/showcase/12164343/embed",
    description: "Communicating product value through clear, engaging storytelling."
  },
  {
    id: 3,
    title: "Retail Solutions",
    thumbnail: "https://customer-assets.emergentagent.com/job_brand-frame/artifacts/6hs8v771_Traverse%20offer%20update.png",
    videoUrl: "https://vimeo.com/showcase/12164406/embed",
    description: "Branding in retail campaigns that connect with real customers and price points."
  },
  {
    id: 4,
    title: "Social Video",
    thumbnail: "https://customer-assets.emergentagent.com/job_brand-frame/artifacts/mw7otxdb_Zolna%20showcase.png",
    videoUrl: "https://vimeo.com/showcase/12164391/embed",
    description: "Short-form content designed for modern platforms and real engagement."
  },
  {
    id: 5,
    title: "Bilingual Storytelling",
    thumbnail: "https://customer-assets.emergentagent.com/job_brand-frame/artifacts/mlaipivh_Bilingual%20Storytelling.png",
    videoUrl: "https://player.vimeo.com/video/13475831",
    description: "English and Spanish content designed for authentic connection."
  },
  {
    id: 6,
    title: "eLearning Expertise",
    thumbnail: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800&q=80",
    videoUrl: "https://vimeo.com/showcase/12005732/embed",
    description: "Transforming complex ideas into clear, engaging video content that people understand and remember."
  }
];

export const services = [
  {
    id: 1,
    title: "Brand Storytelling",
    description: "Helping companies articulate their brand narrative through authentic video and modern storytelling."
  },
  {
    id: 2,
    title: "Social Video Production",
    description: "Short-form video designed for LinkedIn, Instagram, TikTok, and YouTube."
  },
  {
    id: 3,
    title: "Bilingual Content",
    description: "English and Spanish storytelling designed to connect with diverse audiences."
  }
];
